import { gql } from "@apollo/client";

// Subscripción que se activa cuando se recibe un nuevo mensaje de PMV
export const OnLastCCTVMessage = gql`
    subscription OnLastCCTVMessage {
        its_cctv_statuses(
            order_by: { created_at: desc }
            limit: 1
        ) {
            id
            message
            updated_at
            cctv_id
            is_online
        }
    }
`;